/* eslint-disable no-console */
import flagsmith from 'flagsmith';

export default async () => {
  if (process.env.TENANT_TYPE === 'multi') {
    try {
      await flagsmith.init({
        environmentID: process.env.FLAGSMITH_SDK_KEY,
        api: process.env.FLAGSMITH_BASE_URL,
        cacheFlags: false,
        onChange: (oldFlags, params) => {
          console.log('Flags updated:', oldFlags, params);
        },
      });
    } catch (error) {
      console.error('Failed to initialize Flagsmith:', error);
    }
  } else {
    console.log('Tenant type is not multi, skipping Flagsmith initialization');
  }
};



// WEBPACK FOOTER //
// ./src/configs/flagsmith.js